import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import MyTable from '../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../../actions";
import { unoTheme } from '../../../../assets/styles/unoTheme';
import { InstitutionRatesAPI } from '../../../../API/institution_rates';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },
    selectableRow: {
        cursor: "pointer",
        '& > *': {
            borderBottom: 'unset',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },
        '&:hover': {
            backgroundColor: unoTheme.hoverTable,
        }
    },
}));

export default function ClientInstitutionRatesScreen({ clientOnScreen }) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const rightContent = useSelector(state => state.rightContent);

    const [institutionRates, setInstitutionRates] = useState([]);

    async function loadInstitutionRates() {
        if (!clientOnScreen) return;

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Carregando taxas de instituições...'
        }));

        try {
            const response = await InstitutionRatesAPI.getByClient(clientOnScreen.id);

            if (response.success) {
                const rows = response.body?.rows ?? response.body ?? [];
                setInstitutionRates(rows);
            } else {
                setInstitutionRates([]);
            }
        } catch (err) {
            console.error('Erro ao buscar taxas de instituições:', err);
            setInstitutionRates([]);
        }

        // Sempre oculta o innerLoad para manter tabela e botão visíveis
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
    }

    function handleRowClick(row) {
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'institutionRateHistory',
            clientOnScreen,
            data: row,
        }));
    }

    function formatDate(dateStr) {
        if (!dateStr) return '-';
        return moment.utc(dateStr).format('DD/MM/YYYY');
    }

    function formatPercent(value) {
        if (value === null || value === undefined || value === '') return '-';
        return `${parseFloat(value).toFixed(2).replace('.', ',')}%`;
    }

    useEffect(() => {
        if (clientOnScreen) {
            loadInstitutionRates();
        }

        // Quando o right content dispara um action (após salvar), recarrega os dados
        if (rightContent && rightContent.action) {
            loadInstitutionRates();
            dispatch(allActions.rightContentActions.setRightContent(null));
        }

        return () => {
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        };
    }, [clientOnScreen, rightContent]);

    return (
        <div className={classes.root}>

            <div className={'defaultScrollWithHeaderContent'}>
                <MyTable
                    stickyHeader
                    size="small"
                    selectable='true'>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Instituição</TableCell>
                            <TableCell align="left">CNPJ</TableCell>
                            <TableCell align="center">Tx. Custódia (%)</TableCell>
                            <TableCell align="center">Corretagem (%)</TableCell>
                            <TableCell align="center">Data de Inclusão</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {institutionRates.length > 0 ? institutionRates.map((row, index) => (
                            <TableRow
                                key={'institution-rate-' + (row.id || index)}
                                className={classes.selectableRow}
                                onClick={() => handleRowClick(row)}>
                                <TableCell align="left">{row.instituition_name || row.description || '-'}</TableCell>
                                <TableCell align="left">{row.cnpj || '-'}</TableCell>
                                <TableCell align="center">{formatPercent(row.custody_rate)}</TableCell>
                                <TableCell align="center">{formatPercent(row.brokerage_rate)}</TableCell>
                                <TableCell align="center">{formatDate(row.start_date || row.created_at)}</TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={5} align="center" style={{ padding: '24px', color: '#999', fontStyle: 'italic' }}>
                                    Nenhuma instituição cadastrada. Utilize o botão "Incluir Instituição" para adicionar.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </MyTable>
            </div>

        </div>
    );
}